import {
  BaseApiService,
  TransformerConstructor,
} from '@/types';

export class AxiosServicePromiseFactory {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, max-params
  public static async getPromise(
    service: BaseApiService,
    serviceMethod: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    serviceParams: any,
    TransformerClass?: TransformerConstructor,
    transformDeepData: boolean = true,
  ) {
    let transformedServiceParams;
    let transformerInstance;
    if (TransformerClass) {
      transformerInstance = new TransformerClass();
      transformedServiceParams = transformerInstance.send(serviceParams);
    } else {
      transformedServiceParams = serviceParams;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const response = await (service as any)[serviceMethod](transformedServiceParams);

    if (transformDeepData && response.data.data && Array.isArray(response.data.data)) {
      return {
        original: response.data.data,
        response,
        transformed: transformerInstance
          ? transformerInstance.fetchCollection(response.data.data)
          : null,
      };
    }

    if (transformDeepData && response.data.data) {
      return {
        original: response.data.data,
        response,
        transformed: transformerInstance
          ? transformerInstance.fetch(response.data.data)
          : null,
      };
    }

    return {
      original: response.data,
      response,
      transformed: transformerInstance
        ? transformerInstance.fetch(response.data)
        : null,
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public static async getSDKPromise(
    service: BaseApiService,
    serviceMethod: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    serviceParams: any,
    TransformerClass?: TransformerConstructor,
  ) {
    let transformedServiceParams;
    let transformerInstance;

    if (TransformerClass) {
      transformerInstance = new TransformerClass();
      transformedServiceParams = transformerInstance.send(serviceParams);
    } else {
      transformedServiceParams = serviceParams;
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const response = await (service as any)[serviceMethod](transformedServiceParams);
    const returnData = {
      original: response.data,
      response,
      transformed: null,
    };

    if (transformerInstance) {
      returnData.transformed = Array.isArray(response.data)
        ? transformerInstance.fetchCollection(response.data)
        : transformerInstance.fetch(response.data);
    }

    return returnData;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public static async getFakePromise(
    service: BaseApiService,
    serviceMethod: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    serviceParams: any,
    TransformerClass?: TransformerConstructor,
  ) {
    let transformedServiceParams;
    let transformerInstance;
    if (TransformerClass) {
      transformerInstance = new TransformerClass();
      transformedServiceParams = transformerInstance.send(serviceParams);
    } else {
      transformedServiceParams = serviceParams;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const response = await (service as any)[serviceMethod](transformedServiceParams);

    return {
      original: response.data,
      response,
      transformed: transformerInstance
        ? transformerInstance.fetch(response.data)
        : null,
    };
  }
}
